module.exports = __webpack_public_path__ + "img/3.c5ac6a19.png";